import React, { useState } from 'react';
import { Card, Table, Button, Badge, Form, Modal, Spinner } from 'react-bootstrap';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useHistory, useLocation } from 'react-router-dom';
import Pagination from 'react-js-pagination';
import { CME_DIEU_DUONG_API, ACCOUNTINFO_API, FILE_MANAGER_API, ACCOUNT_API, ACCOUNT_AUTHINFO_API, SIGNEDHUMAN_API, KYSO_API, BaseGatewayImage } from '../../../../utils/apiUrl';
import { Get, Post, PostFormData, DeleteSingle } from '../../../../utils/httpProvider';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';
import CMEDieuDuongEventAddEditModal from './CMEDieuDuongEventAddEditModal';
import UserInfoCell from '../duyetHoSo/UserInfoCell';
import CMEParticipantCell from '../duyetHoSo/CMEParticipantCell';
import moment from 'moment';
import { exportToWordPhuLuc2 } from './cmeDieuDuongExportHelper';
import { objectChuKy, objectLoaiKy, objectShowNumber, styleSelectDefault } from '../../../../utils/define';
import { createUrlWithParam } from '../../../../utils/helper';
import { AsyncPaginate } from 'react-select-async-paginate';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/js/pdf.worker.min.js`;

// Helper component to display Unit/Department (Hybrid: app_dungchung first, local fallback)
const UserUnitCell = ({ userId }) => {
    const { data: sharedInfo } = useQuery(
        ['sharedAccountInfoUnit', userId],
        () => Get(ACCOUNT_API.GET_ACCOUNT_INFO_BYID_FROM_APP_DUNGCHUNG, userId),
        { enabled: !!userId, staleTime: 600000, cacheTime: 900000 }
    );

    const donVis = sharedInfo?.donVis || sharedInfo?.DonVis?.$values || sharedInfo?.DonVis || [];
    const maDonVi = (Array.isArray(donVis) && donVis.length > 0)
        ? donVis.map(d => d.maDonVi || d.MaDonVi || d.tenDonVi || d.TenDonVi).filter(Boolean).join(', ')
        : '-';

    return <span>{maDonVi}</span>;
};

const CMEDieuDuongEvent = () => {
    const queryClient = useQueryClient();
    const history = useHistory();
    const location = useLocation();

    // Parse URL search params
    const paramUrl = new URLSearchParams(location.search);
    const initialPage = paramUrl.get('page') != null ? parseInt(paramUrl.get('page'), 10) : 1;
    const initialPageSize = paramUrl.get('size') != null ? parseInt(paramUrl.get('size'), 10) : 20;
    const initialKeyword = paramUrl.get('search') != null ? paramUrl.get('search') : '';

    const [page, setPage] = useState(initialPage);
    const [pageSize, setPageSize] = useState(initialPageSize);
    const [keyword, setKeyword] = useState(initialKeyword);

    const [openAddEditModal, setOpenAddEditModal] = useState(false);
    const [selectedData, setSelectedData] = useState(null);

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [deleteName, setDeleteName] = useState('');

    const [openAttendanceModal, setOpenAttendanceModal] = useState(false);
    const [currentEvent, setCurrentEvent] = useState(null);

    const [uploadingDiemDanhId, setUploadingDiemDanhId] = useState(null);
    const [minhChungFile, setMinhChungFile] = useState(null);

    // Sync state with URL when URL changes
    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        const p = params.get('page') != null ? parseInt(params.get('page'), 10) : 1;
        const s = params.get('size') != null ? parseInt(params.get('size'), 10) : 20;
        const kw = params.get('search') != null ? params.get('search') : '';

        if (p !== page) setPage(p);
        if (s !== pageSize) setPageSize(s);
        if (kw !== keyword) setKeyword(kw);
    }, [location.search]);

    const cleanParams = (params) => {
        const result = {};
        Object.entries(params).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                result[key] = value;
            }
        });
        return result;
    };

    const replaceHistory = (Page, Size, Search) => {
        const rawParams = {
            page: Page,
            size: Size,
            search: Search || null,
        };
        history.replace(
            createUrlWithParam(location.pathname, cleanParams(rawParams))
        );
    };

    // Ensure default params exist in URL on mount
    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get('page') == null || params.get('size') == null || params.get('search') == null) {
            replaceHistory(page, pageSize, keyword);
        }
    }, []);

    const changePage = (number) => {
        replaceHistory(number, pageSize, keyword);
    };

    const onChangeShowNumber = (e) => {
        const val = Number(e.target.value);
        replaceHistory(1, val, keyword);
    };

    const onChangeKeyword = (e) => {
        const val = e.target.value;
        replaceHistory(1, pageSize, val);
    };

    // Queries
    const { data: eventsPagingData, isLoading, refetch } = useQuery(
        ['cmeDieuDuongEventsPaging', keyword, page, pageSize],
        () => Get(`${CME_DIEU_DUONG_API.GET_PAGING}?keyword=${keyword}&pageIndex=${page}&pageSize=${pageSize}`),
        { keepPreviousData: true }
    );

    const deleteMutation = useMutation(async (id) => {
        const res = await DeleteSingle(CME_DIEU_DUONG_API.DELETE, id);
        if (!res.ok) {
            const text = await res.text();
            let errorData;
            try {
                errorData = JSON.parse(text);
            } catch (e) {
                errorData = { message: text };
            }
            throw errorData;
        }
        return res;
    });
    const toggleCheckinMutation = useMutation(({ id, enabled }) => Post(`${CME_DIEU_DUONG_API.TOGGLE_CHECKIN}/${id}`, null, enabled));
    const toggleCheckoutMutation = useMutation(({ id, enabled }) => Post(`${CME_DIEU_DUONG_API.TOGGLE_CHECKOUT}/${id}`, null, enabled));

    const eventList = eventsPagingData?.data?.$values || eventsPagingData?.data || eventsPagingData?.Data?.$values || eventsPagingData?.Data || [];
    const totalRecords = eventsPagingData?.totalRecords || eventsPagingData?.TotalRecords || 0;

    const handleAdd = () => {
        setSelectedData(null);
        setOpenAddEditModal(true);
    };

    const handleEdit = (item) => {
        setSelectedData(item);
        setOpenAddEditModal(true);
    };

    const handleDelete = (item) => {
        setIdWantDelete(item.id);
        setDeleteName(item.tenKhoaDaoTao);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        deleteMutation.mutate(idWantDelete, {
            onSuccess: () => {
                toast.success("Xóa khóa đào tạo thành công.");
                refetch();
                setOpenConfirmDeleteModal(false);
            },
            onError: (err) => {
                toast.error(err?.message || "Lỗi khi xóa.");
            }
        });
    };

    const handleToggleCheckin = (id, enabled) => {
        toggleCheckinMutation.mutate({ id, enabled }, {
            onSuccess: () => {
                toast.success(enabled ? "Đã bật điểm danh tham gia." : "Đã tắt điểm danh tham gia.");
                refetch();
            }
        });
    };

    const handleToggleCheckout = (id, enabled) => {
        toggleCheckoutMutation.mutate({ id, enabled }, {
            onSuccess: () => {
                toast.success(enabled ? "Đã bật điểm danh kết thúc." : "Đã tắt điểm danh kết thúc.");
                refetch();
            }
        });
    };

    return (
        <div className="container-fluid">
            <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-white border-bottom d-flex justify-content-between align-items-center py-3">
                    <h5 className="mb-0 text-primary font-weight-bold">
                        <i className="fas fa-user-nurse mr-2"></i>CME Điều dưỡng - Quản lý sinh hoạt & Đào tạo
                    </h5>
                    <Button variant="primary" size="sm" onClick={handleAdd} className="shadow-sm">
                        <i className="fas fa-plus mr-1"></i>Tạo khóa đào tạo mới
                    </Button>
                </Card.Header>
                <Card.Body>
                    <div className="row mb-4">
                        <div className="col-md-6">
                            <Form.Control
                                type="text"
                                placeholder="Tìm kiếm tên khóa học/hoạt động..."
                                value={keyword}
                                onChange={onChangeKeyword}
                            />
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Table hover className="align-middle">
                            <thead className="bg-light text-muted text-uppercase" style={{ fontSize: '0.8rem' }}>
                                <tr>
                                    <th style={{ width: '50px' }}>STT</th>
                                    <th>Tên Khóa đào tạo / Hoạt động</th>
                                    <th style={{ width: '180px' }}>Thời gian</th>
                                    <th style={{ width: '100px' }}>Số giờ CME</th>
                                    <th style={{ width: '220px' }}>Điểm danh tham gia</th>
                                    <th style={{ width: '220px' }}>Điểm danh kết thúc</th>
                                    <th style={{ width: '120px' }}>Trạng thái</th>
                                    <th style={{ width: '200px' }} className="text-center">Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan={8} className="text-center py-4">Đang tải dữ liệu...</td></tr>
                                ) : eventList.length === 0 ? (
                                    <tr><td colSpan={8} className="text-center py-4 text-muted">Chưa có khóa học nào.</td></tr>
                                ) : (
                                    eventList.map((item, idx) => (
                                        <tr key={item.id}>
                                            <td>{(page - 1) * pageSize + idx + 1}</td>
                                            <td>
                                                <div className="font-weight-bold text-dark">{item.tenKhoaDaoTao}</div>
                                                <small className="text-muted"><i className="fas fa-map-marker-alt mr-1"></i>{item.diaDiem || 'N/A'}</small>
                                            </td>
                                            <td>
                                                <div style={{ fontSize: '0.85rem' }}>
                                                    <div>Từ: {moment(item.tuNgay).format('DD/MM/YYYY')}</div>
                                                    <div>Đến: {moment(item.denNgay).format('DD/MM/YYYY')}</div>
                                                </div>
                                            </td>
                                            <td className="text-center font-weight-bold">{item.soGioTinChi}h</td>
                                            <td>
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id={`checkinSwitch-${item.id}`}
                                                        checked={item.choPhepDiemDanhBatDau}
                                                        onChange={(e) => handleToggleCheckin(item.id, e.target.checked)}
                                                    />
                                                    <label className="custom-control-label font-weight-bold" htmlFor={`checkinSwitch-${item.id}`}>
                                                        {item.choPhepDiemDanhBatDau ? "ĐANG MỞ CHỜ CHECK-IN" : "ĐÃ TẮT"}
                                                    </label>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id={`checkoutSwitch-${item.id}`}
                                                        checked={item.choPhepDiemDanhKetThuc}
                                                        onChange={(e) => handleToggleCheckout(item.id, e.target.checked)}
                                                    />
                                                    <label className="custom-control-label font-weight-bold" htmlFor={`checkoutSwitch-${item.id}`}>
                                                        {item.choPhepDiemDanhKetThuc ? "ĐANG MỞ CHỜ CHECK-OUT" : "ĐÃ TẮT"}
                                                    </label>
                                                </div>
                                            </td>
                                            <td>
                                                {item.trangThai === 0 && <Badge variant="secondary">Đã thông báo</Badge>}
                                                {item.trangThai === 1 && <Badge variant="warning text-white">Đang diễn ra</Badge>}
                                                {item.trangThai === 2 && <Badge variant="success">Đã kết thúc</Badge>}
                                            </td>
                                            <td className="text-center">
                                                <Button
                                                    variant="outline-info"
                                                    size="sm"
                                                    className="mr-1"
                                                    onClick={() => {
                                                        setCurrentEvent(item);
                                                        setOpenAttendanceModal(true);
                                                    }}
                                                >
                                                    <i className="fas fa-list mr-1"></i>Điểm danh
                                                </Button>
                                                <Button variant="link" size="sm" className="text-info p-0 mr-2" onClick={() => handleEdit(item)}>Sửa</Button>
                                                <Button variant="link" size="sm" className="text-danger p-0" onClick={() => handleDelete(item)}>Xóa</Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '80px' }}>
                            {objectShowNumber.map(opt => <option key={opt.value} value={opt.value}>{opt.text}</option>)}
                        </Form.Control>
                        <Pagination
                            activePage={page}
                            itemsCountPerPage={pageSize}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={5}
                            onChange={changePage}
                            itemClass="page-item"
                            linkClass="page-link"
                        />
                    </div>
                </Card.Body>
            </Card>

            <ConfirmModal
                isOpen={openConfirmDeleteModal}
                confirmType="confirm"
                labelAccept="Xóa"
                handleAccept={acceptDelete}
                handleCancel={() => setOpenConfirmDeleteModal(false)}
                content={`Bạn có chắc chắn muốn xóa khóa học: "${deleteName}"?`}
            />

            <CMEDieuDuongEventAddEditModal
                isOpen={openAddEditModal}
                handleClose={() => setOpenAddEditModal(false)}
                data={selectedData}
                refetch={refetch}
            />

            {openAttendanceModal && currentEvent && (
                <AttendanceDetailModal
                    isOpen={openAttendanceModal}
                    handleClose={() => setOpenAttendanceModal(false)}
                    eventData={currentEvent}
                />
            )}
        </div>
    );
};

// Sub-component: Attendance checklist & Step 1 Approval Modal
const AttendanceDetailModal = ({ isOpen, handleClose, eventData }) => {
    const queryClient = useQueryClient();
    const [selectedIds, setSelectedIds] = useState([]);
    const [minhChungUrl, setMinhChungUrl] = useState('');
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [isSavingList, setIsSavingList] = useState(false);
    const [submittingStep1, setSubmittingStep1] = useState(false);
    const [isResettingFile, setIsResettingFile] = useState(false);
    const [unitMap, setUnitMap] = useState({});
    const [userMap, setUserMap] = useState({});

    const [downloadUrl, setDownloadUrl] = useState('');
    const hasLocalFileActionRef = React.useRef(false);

    // Search state
    const [keyword, setKeyword] = useState('');

    const { data: list, isLoading, refetch } = useQuery(
        ['cmeAttendanceList', eventData?.id],
        () => Get(`${CME_DIEU_DUONG_API.GET_ATTENDANCE}/${eventData?.id}`),
        { enabled: !!eventData?.id && isOpen }
    );

    const { data: eventDetail } = useQuery(
        ['cmeDieuDuongEventFileState', eventData?.id],
        () => Get(`${CME_DIEU_DUONG_API.GET_BY_ID}/${eventData?.id}`),
        { enabled: !!eventData?.id && isOpen }
    );

    const currentEventState = eventDetail || eventData;
    const recordList = list?.$values || list || [];

    // Batch resolve user unit codes and account info (for search/sorting)
    React.useEffect(() => {
        const fetchDetails = async () => {
            if (recordList.length === 0) return;
            const uniqueUserIds = [...new Set(recordList.map(x => x.userId))].filter(id => !unitMap[id] || !userMap[id]);
            if (uniqueUserIds.length === 0) return;

            const newUnits = { ...unitMap };
            const newUsers = { ...userMap };
            await Promise.all(uniqueUserIds.map(async (userId) => {
                try {
                    // Dùng AccountAuthInfo/GetItem (quyền thấp hơn Account/GetItem)
                    const accountInfo = await Get(ACCOUNT_AUTHINFO_API.GET_BY_ID_ACCOUNT, userId);
                    queryClient.setQueryData(['accountInfo', userId], accountInfo);

                    // AccountAuthInfo/GetItem trả về fields trực tiếp, fallback về nested nếu cần
                    const authInfo = accountInfo?.accountAuthInfo || accountInfo?.AccountAuthInfo || accountInfo;
                    const fullName = [
                        authInfo?.lastName || authInfo?.LastName,
                        authInfo?.middleName || authInfo?.MiddleName,
                        authInfo?.firstName || authInfo?.FirstName
                    ].filter(Boolean).join(' ') || 'Chưa cập nhật';
                    const username = accountInfo?.username || accountInfo?.Username || '';
                    newUsers[userId] = { fullName, username };

                    // Fetch unit details
                    let donVis = [];
                    try {
                        const sharedInfo = await Get(ACCOUNT_API.GET_ACCOUNT_INFO_BYID_FROM_APP_DUNGCHUNG, userId);
                        let localInfo = null;
                        if (!sharedInfo?.donVis && !sharedInfo?.DonVis) {
                            localInfo = await Get(ACCOUNTINFO_API.GET_BY_ACCOUNT_ID, userId);
                        }
                        donVis = sharedInfo?.donVis || sharedInfo?.DonVis?.$values || sharedInfo?.DonVis || localInfo?.donVis || [];
                    } catch (unitErr) {
                        console.warn("Lỗi khi lấy thông tin đơn vị cho user:", userId, unitErr);
                    }

                    if (donVis && donVis.length > 0) {
                        const unitObj = donVis[0];
                        const code = unitObj.maDonVi || unitObj.MaDonVi || unitObj.tenDonVi || unitObj.TenDonVi || '-';
                        newUnits[userId] = { code };
                    } else {
                        newUnits[userId] = { code: '-' };
                    }
                } catch (e) {
                    newUnits[userId] = { code: '-' };
                    newUsers[userId] = { fullName: 'Chưa cập nhật', username: '' };
                }
            }));
            setUnitMap(newUnits);
            setUserMap(newUsers);
        };
        fetchDetails();
    }, [recordList]);

    React.useEffect(() => {
        if (recordList.length > 0) {
            setSelectedIds(recordList.filter(x => x.trangThaiDuyet === 4 || x.trangThaiDuyet === 1 || x.trangThaiDuyet === 3).map(x => x.id));
        }
    }, [list]);

    // Filter and Sort list alphabetically by MaDonVi
    const filteredAndSortedList = React.useMemo(() => {
        let result = [...recordList];

        if (keyword.trim()) {
            const kw = keyword.trim().toLowerCase();
            result = result.filter(item => {
                const user = userMap[item.userId];
                const unit = unitMap[item.userId];
                const fullName = user?.fullName?.toLowerCase() || '';
                const username = user?.username?.toLowerCase() || '';
                const unitCode = unit?.code?.toLowerCase() || '';
                return fullName.includes(kw) || username.includes(kw) || unitCode.includes(kw);
            });
        }

        return result.sort((a, b) => {
            const unitA = unitMap[a.userId];
            const unitB = unitMap[b.userId];
            const codeA = unitA ? unitA.code : '';
            const codeB = unitB ? unitB.code : '';
            return codeA.localeCompare(codeB, 'vi');
        });
    }, [recordList, unitMap, userMap, keyword]);

    const handleSelectAll = (checked) => {
        const activeIds = filteredAndSortedList.filter(x => x.trangThaiDuyet === 0).map(x => x.id);
        const lockedIds = recordList.filter(x => x.trangThaiDuyet === 4 || x.trangThaiDuyet === 1 || x.trangThaiDuyet === 3).map(x => x.id);
        if (checked) {
            setSelectedIds(prev => [...new Set([...prev, ...activeIds])]);
        } else {
            setSelectedIds(prev => prev.filter(id => !activeIds.includes(id) || lockedIds.includes(id)));
        }
    };

    const handleSelectOne = (id, checked) => {
        const item = recordList.find(x => x.id === id);
        if (item && (item.trangThaiDuyet === 4 || item.trangThaiDuyet === 1 || item.trangThaiDuyet === 3)) {
            return; // Locked item cannot be deselected or changed
        }
        if (checked) {
            setSelectedIds(prev => [...prev, id]);
        } else {
            setSelectedIds(prev => prev.filter(x => x !== id));
        }
    };

    const resolveSignedPdfUrl = (url) => {
        if (!url) return '';
        if (url.startsWith('http')) return url;
        return `${BaseGatewayImage}${url.startsWith('/') ? '' : '/'}${url}`;
    };

    const getFileNameFromUrl = (url) => {
        const path = (url || '').split('?')[0];
        return path.split('/').pop() || `minh-chung-${moment().format('YYYYMMDDHHmmss')}.pdf`;
    };

    const deleteSignedTempFile = async (url) => {
        if (!url) return;

        try {
            await DeleteSingle(FILE_MANAGER_API.DELETE_FILE_PATH, null, {
                filePath: url
            });
        } catch (err) {
            console.warn('Không xóa được file tạm fileSign.', err);
        }
    };

    const handleUploadMinhChung = async (e) => {
        if (!downloadUrl) {
            toast.warning("Vui lòng ký số để tạo file PDF trước khi tải minh chứng.");
            return;
        }

        if (!hasAllRequiredSignatures) {
            toast.warning("Vui lòng ký đủ 2 chữ ký trước khi lấy PDF đã ký.");
            return;
        }

        setIsUploadingFile(true);
        try {
            const signedPdfRes = await fetch(resolveSignedPdfUrl(downloadUrl));
            if (!signedPdfRes.ok) {
                throw new Error('Không tải được file PDF đã ký.');
            }

            const blob = await signedPdfRes.blob();
            const file = new File([blob], getFileNameFromUrl(downloadUrl), { type: blob.type || 'application/pdf' });
            const formData = new FormData();
            formData.append('file', file);

            const res = await PostFormData(FILE_MANAGER_API.UPLOAD, formData);
            const uploadedFile = Array.isArray(res) ? res[0] : res;
            const fileUrl = uploadedFile?.filePath || uploadedFile?.FilePath || uploadedFile?.path || uploadedFile?.fileUrl || res?.path || res?.fileUrl;
            if (fileUrl) {
                hasLocalFileActionRef.current = true;
                setMinhChungUrl(fileUrl);
                toast.success("Tải file minh chứng từ PDF đã ký thành công!");
                await persistPhuLuc2FileState({ minhChungUrl: fileUrl });
            } else {
                toast.error("Không nhận được đường dẫn file từ Server.");
            }
        } catch (err) {
            toast.error(err?.message || "Lỗi khi upload file minh chứng.");
        } finally {
            setIsUploadingFile(false);
        }
        if (downloadUrl) return;

        if (e.target.files && e.target.files[0]) {
            setIsUploadingFile(true);
            const file = e.target.files[0];
            const formData = new FormData();
            formData.append('file', file);
            try {
                const res = await PostFormData(FILE_MANAGER_API.UPLOAD, formData);
                const uploadedFile = Array.isArray(res) ? res[0] : res;
                const fileUrl = uploadedFile?.filePath || uploadedFile?.FilePath || uploadedFile?.path || uploadedFile?.fileUrl || res?.path || res?.fileUrl;
                if (fileUrl) {
                    setMinhChungUrl(fileUrl);
                    toast.success("Tải file minh chứng thành công!");
                } else {
                    toast.error("Không nhận được đường dẫn file từ Server.");
                }
            } catch (err) {
                toast.error("Lỗi khi upload file.");
            } finally {
                setIsUploadingFile(false);
            }
        }
    };

    const handleSaveList = async () => {
        setIsSavingList(true);
        try {
            await Post(`${CME_DIEU_DUONG_API.SAVE_LIST}/${eventData.id}`, null, selectedIds);
            toast.success("Lưu danh sách thành công!");
            refetch();
        } catch (err) {
            toast.error(err?.message || "Lỗi khi lưu danh sách.");
        } finally {
            setIsSavingList(false);
        }
    };

    const handleSubmitStep1 = async () => {
        const savedIds = recordList.filter(x => x.trangThaiDuyet === 4).map(x => x.id);
        if (savedIds.length === 0) {
            toast.error("Vui lòng lưu danh sách học viên trước khi duyệt.");
            return;
        }
        if (!minhChungUrl) {
            toast.error("Vui lòng tải lên file minh chứng trước khi duyệt.");
            return;
        }

        if (!hasAllRequiredSignatures) {
            toast.error("Vui lòng ký đủ 2 chữ ký trước khi duyệt.");
            return;
        }

        setSubmittingStep1(true);
        try {
            await Post(`${CME_DIEU_DUONG_API.APPROVE_STEP1}/${eventData.id}`, null, {
                diemDanhIds: savedIds,
                minhChungUrl: minhChungUrl
            });
            toast.success("Duyệt danh sách Bước 1 thành công!");
            refetch();
        } catch (err) {
            toast.error(err?.message || "Lỗi khi duyệt.");
        } finally {
            setSubmittingStep1(false);
        }
    };

    // const addFunc = useMutation((value) =>
    //     Post(SIGNEDHUMAN_API.EXPORT_PDF, null, value, false)
    // );

    // const handleExport = async (values) => {
    //     const model = {...values};

    //     addFunc.mutate(model, {
    //         onSuccess: (res) => {
    //             if (res.status !== status200) {
    //                 toast.error(messageToast.messageToastCreateError);
    //             } else {
    //                 setIsLoading(true);
    //                 toast.success(messageToast.messageToastCreateSuccess);
    //                 history.goBack();
    //             }
    //         },
    //         onError: (res) => {
    //             toast.error(
    //                 res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
    //             );
    //         }
    //     });
    // };

    const [docxFileId, setDocxFileId] = useState('');
    const [docxFilePath, setDocxFilePath] = useState('');

    const [filePathAbsolute, setFilePathAbsolute] = useState('');
    const [openBulkActionModal, setOpenBulkActionModal] = useState(false);
    const [bulkUsername, setBulkUsername] = useState('');
    const [bulkPassword, setBulkPassword] = useState('');

    const [signedFields, setSignedFields] = useState([]);
    const [openPdfViewer, setOpenPdfViewer] = useState(false);

    const [numPages, setNumPages] = useState(0);
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    }

    const getFileNameFromPath = (path) => {
        if (!path) return '';
        const parts = path.split(/[\\/]/);
        return parts[parts.length - 1] || path;
    };

    const getRelativeFilePath = (absolutePath) => {
        if (!absolutePath) return '';

        const normalizedPath = absolutePath.replace(/\\/g, '/');
        const match = normalizedPath.match(/(?:^|\/)(files|fileSign|cachedDocument)\/(.+)$/i);
        if (match) {
            return `${match[1]}/${match[2]}`;
        }

        return normalizedPath.split('/').pop() || normalizedPath;
    };

    const parseSignedFields = (value) => {
        if (!value) return [];
        if (Array.isArray(value)) return value.filter(Boolean);
        return String(value).split(',').map(x => x.trim()).filter(Boolean);
    };

    const hasAllRequiredSignatures = objectChuKy.every(x => signedFields.includes(x.value));

    const persistPhuLuc2FileState = async (nextState = {}) => {
        if (!eventData?.id) return;

        await Post(`${CME_DIEU_DUONG_API.SAVE_PHU_LUC_2_FILE_STATE}/${eventData.id}`, null, {
            filePathAbsolute: nextState.filePathAbsolute ?? filePathAbsolute,
            downloadUrl: nextState.downloadUrl ?? downloadUrl,
            signedFields: nextState.signedFields ?? signedFields,
            minhChungUrl: nextState.minhChungUrl ?? minhChungUrl
        });
    };

    React.useEffect(() => {
        if (!isOpen) {
            hasLocalFileActionRef.current = false;
        }
    }, [isOpen, eventData?.id]);

    React.useEffect(() => {
        if (!isOpen || !currentEventState || hasLocalFileActionRef.current) return;

        const savedFilePath = currentEventState.phuLuc2FilePathAbsolute || currentEventState.PhuLuc2FilePathAbsolute || '';
        const savedDownloadUrl = currentEventState.phuLuc2DownloadUrl || currentEventState.PhuLuc2DownloadUrl || '';
        const savedSignedFields = currentEventState.phuLuc2SignedFields || currentEventState.PhuLuc2SignedFields || '';
        const savedMinhChungUrl = currentEventState.phuLuc2MinhChungUrl || currentEventState.PhuLuc2MinhChungUrl || '';

        setFilePathAbsolute(savedFilePath);
        setDownloadUrl(savedDownloadUrl || getRelativeFilePath(savedFilePath));
        setSignedFields(parseSignedFields(savedSignedFields));
        setMinhChungUrl(savedMinhChungUrl);
    }, [isOpen, currentEventState]);

    const handleCloseBulkActionModal = () => {
        setOpenBulkActionModal(false);
        setBulkUsername('');
        setBulkPassword('');
    };

    const [bulkLoaiKy, setBulkLoaiKy] = useState(
        objectLoaiKy && objectLoaiKy.length > 0 ? objectLoaiKy[0].value : ''
    );

    const [bulkChuKy, setBulkChuKy] = useState(
        objectChuKy && objectChuKy.length > 0 ? objectChuKy[0].value : ''
    );

    // Export Word Document (Phụ lục 2)
    const handleExportPhuLuc = async () => {
        const savedRecords = filteredAndSortedList.filter(x => x.trangThaiDuyet === 4 || x.trangThaiDuyet === 1 || x.trangThaiDuyet === 3);
        if (savedRecords.length === 0) {
            toast.warning("Chưa có danh sách được lưu hoặc duyệt để xuất phụ lục.");
            return;
        }
        // console.log("Exporting Phụ lục 2 with records:", savedRecords);
        var result = await exportToWordPhuLuc2(savedRecords, currentEventState, docxFilePath);

        if (result) {
            hasLocalFileActionRef.current = true;
            const newDownloadUrl = getRelativeFilePath(result);
            setFilePathAbsolute(result);
            setDownloadUrl(newDownloadUrl);
            setSignedFields([]);
            setMinhChungUrl('');
            await persistPhuLuc2FileState({
                filePathAbsolute: result,
                downloadUrl: newDownloadUrl,
                signedFields: [],
                minhChungUrl: ''
            });
        }

        // handleExport(savedRecords);
    };

    const handleResetPhuLuc2File = async () => {
        if (!filePathAbsolute && !downloadUrl && !minhChungUrl && signedFields.length === 0) {
            toast.info('Chưa có file để reset.');
            return;
        }

        const accepted = window.confirm('Việc reset file sẽ xóa các bản đã xuất/ký và bắt đầu lại từ đầu. Bạn có chắc chắn?');
        if (!accepted) return;

        setIsResettingFile(true);
        try {
            await Post(`${CME_DIEU_DUONG_API.RESET_PHU_LUC_2_FILE_STATE}/${eventData.id}`, null, {});
            hasLocalFileActionRef.current = true;
            setFilePathAbsolute('');
            setDownloadUrl('');
            setSignedFields([]);
            setMinhChungUrl('');
            setNumPages(0);
            setOpenPdfViewer(false);
            queryClient.invalidateQueries(['cmeDieuDuongEventFileState', eventData?.id]);
            toast.success('Thành công xóa file. Bạn có thể xuất lại Phụ lục 2 từ đầu.');
        } catch (err) {
            toast.error(err?.message || 'Lỗi khi xóa file.');
        } finally {
            setIsResettingFile(false);
        }
    };

    const hasSavedItems = recordList.some(x => x.trangThaiDuyet === 4);

    const loadOptionsDocxFile = async (search, loadedOptions, { page }) => {
        const pageSize = 10;
        const res = await Get(FILE_MANAGER_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            IsTemplate: true,
            Keyword: search, // pass the input text to filter server-side
            FileType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.filePath}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: { page: page + 1 }
        };
    };

    const addFunc = useMutation((value) =>
        Post(KYSO_API.KYSO_ONE_FILE_ONE_SIGNATURE, null, value, false, false, true)
    );

    // const handleConfirmBulkAction = async () => {
    //     // if (!selectedIds || selectedIds.length === 0) {
    //     //     toast.warning('Vui lòng chọn ít nhất một bản ghi');
    //     //     return;
    //     // }

    //     // if (selectedIds.length > 10) {
    //     //     toast.warning('Chỉ được xuất tối đa 10 file mỗi lần');
    //     //     return;
    //     // }

    //     if (!bulkUsername || !bulkPassword) {
    //         toast.warning('Vui lòng nhập username và password');
    //         return;
    //     }
    //     const model = {
    //         userName: bulkUsername,
    //         password: bulkPassword,
    //         mid: objectLoaiKy.find(x => x.value == bulkLoaiKy).value,
    //         signatureName: objectChuKy.find(x => x.value == bulkChuKy).value,
    //         filePathAbsolute: filePathAbsolute
    //         // selectedIds: selectedIds
    //     };

    //     // model.parentId = values.parentId === 'null' ? '' : values.parentId;
    //     // model.parentId = '';
    //     addFunc.mutateAsync(model, {
    //         onSuccess: async (res) => {
    //             if (res.status !== status200) {
    //                 toast.error(messageToast.messageToastCreateError);
    //             } else {
    //                 const contentType = res.headers?.['content-type'] || 'application/zip';

    //                 let fileName = `signed_files_${new Date().getTime()}.zip`;
    //                 const disposition = res.headers?.['content-disposition'];
    //                 if (disposition) {
    //                     const match = disposition.match(/filename="?([^"]+)"?/);
    //                     if (match && match[1]) {
    //                         fileName = match[1];
    //                     }
    //                 }

    //                 const blob = await res.blob();

    //                 if (!blob || blob.size === 0) {
    //                     toast.error('File zip rỗng hoặc không hợp lệ');
    //                     return;
    //                 }

    //                 const url = window.URL.createObjectURL(blob);

    //                 const a = document.createElement('a');
    //                 a.href = url;
    //                 a.download = fileName;
    //                 document.body.appendChild(a);
    //                 a.click();
    //                 a.remove();

    //                 window.URL.revokeObjectURL(url);

    //                 toast.success(messageToast.messageToastCreateSuccess);
    //                 setOpenBulkActionModal(false);
    //                 replaceHistory(page, pageSize, valueSearch);
    //             }
    //         },
    //         onError: (res) => {
    //             toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
    //         }
    //     });
    // };

    const handleConfirmBulkAction = async () => {
        if (!filePathAbsolute) {
            toast.warning('Vui lòng xuất Phụ lục 2 trước khi ký');
            return;
        }

        if (!bulkUsername || !bulkPassword) {
            toast.warning('Vui lòng nhập username và password');
            return;
        }

        if (signedFields.includes(bulkChuKy)) {
            toast.warning('Ô ký này đã được ký rồi');
            return;
        }

        const nextSignedFields = [...new Set([...signedFields, bulkChuKy])];
        const isFinalSignature = objectChuKy.every(x =>
            nextSignedFields.includes(x.value)
        );

        const model = {
            userName: bulkUsername,
            password: bulkPassword,
            mid: objectLoaiKy.find(x => x.value == bulkLoaiKy)?.value,
            signatureName: bulkChuKy,
            filePathAbsolute,
            filePath: getRelativeFilePath(filePathAbsolute),
            isFinalSignature
        };

        addFunc.mutateAsync(model, {
            onSuccess: async (res) => {
                // const data = await res.json();

                if (!res?.success) {
                    toast.error(res?.message || 'Ký số thất bại');
                    return;
                }

                hasLocalFileActionRef.current = true;
                setSignedFields(nextSignedFields);
                setFilePathAbsolute(res.filePathAbsolute);

                // downloadFileFromUrl(res.downloadUrl, res.fileName);
                setOpenPdfViewer(true);
                setDownloadUrl(res.downloadUrl);
                await persistPhuLuc2FileState({
                    filePathAbsolute: res.filePathAbsolute,
                    downloadUrl: res.downloadUrl,
                    signedFields: nextSignedFields
                });

                toast.success(
                    isFinalSignature
                        ? 'Ký hoàn tất, file đã được lưu vào fileSign.'
                        : 'Ký thành công, file tạm đã được lưu vào cachedDocument.'
                );

                setOpenBulkActionModal(false);
            },
            onError: () => {
                toast.error('Đã có lỗi xảy ra, vui lòng thử lại!');
            }
        });
    };

    const handleOpenBulkActionModal = () => {
        // if (selectedIds.length === 0) {
        //     toast.warning('Vui lòng chọn ít nhất một bản ghi');
        //     return;
        // }
        setBulkUsername('');
        setBulkPassword('');
        setOpenBulkActionModal(true);
    };

    return (
        <>
            <Modal show={isOpen} onHide={handleClose} size="xl" backdrop="static" style={{ zIndex: '9999' }}>
                <Modal.Header closeButton className="cme-header" style={{ borderBottom: 'none' }}>
                    <Modal.Title className="text-primary font-weight-bold">
                        <i className="fas fa-list-alt mr-2"></i>Điểm danh & Duyệt danh sách: {eventData?.tenKhoaDaoTao}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-3" style={{ gap: '12px' }}>
                        <div className="d-flex flex-wrap align-items-center" style={{ flex: 1, gap: '8px' }}>
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={handleSaveList}
                                disabled={isSavingList}
                                style={{ borderRadius: '8px', fontWeight: 600 }}
                            >
                                {isSavingList ? <Spinner animation="border" size="sm" /> : <><i className="fas fa-save mr-1"></i>Lưu danh sách</>}
                            </Button>
                            <AsyncPaginate
                                name="docxFileId"
                                id="docxFileId"
                                placeholder="Chọn file docx"
                                value={docxFileId}
                                loadOptions={loadOptionsDocxFile}
                                styles={styleSelectDefault}
                                isClearable
                                onChange={(selectedOption) => {
                                    setDocxFileId(selectedOption);
                                    setDocxFilePath(selectedOption?.label || '');
                                    // setFieldValue(
                                    //     'docxFileId',
                                    //     selectedOption,
                                    //     true
                                    // );
                                }}
                                additional={{
                                    page: 1
                                }}
                            />
                            <Button className="modern-btn-success" size="sm" onClick={handleExportPhuLuc}>
                                <i className="fas fa-file-word mr-1"></i>Xuất Phụ lục 2
                            </Button>
                            <button
                                type="button"
                                className="btn btn-danger mr-2"
                                onClick={() => setOpenPdfViewer(true)}
                            >
                                Xem lại file
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger mr-2"
                                onClick={handleOpenBulkActionModal}
                            >
                                Login để ký số
                            </button>
                            <Form.Control
                                type="text"
                                placeholder="Tìm kiếm theo tên, CCCD hoặc mã đơn vị..."
                                value={keyword}
                                onChange={(e) => setKeyword(e.target.value)}
                                size="sm"
                                style={{ borderRadius: '8px', maxWidth: '320px', minWidth: '240px', flex: '1 1 auto' }}
                            />
                            <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={handleResetPhuLuc2File}
                                disabled={isResettingFile || (!filePathAbsolute && !downloadUrl && !minhChungUrl && signedFields.length === 0)}
                                style={{ borderRadius: '8px', fontWeight: 600 }}
                            >
                                {isResettingFile ? <Spinner animation="border" size="sm" /> : <><i className="fas fa-redo mr-1"></i>Reset file</>}
                            </Button>
                        </div>
                        <div className="d-flex flex-wrap align-items-center" style={{ gap: '8px' }}>
                            <Button
                                variant={minhChungUrl ? "success" : "outline-primary"}
                                size="sm"
                                onClick={handleUploadMinhChung}
                                disabled={!downloadUrl || !hasAllRequiredSignatures || isUploadingFile}
                                style={{ borderRadius: '8px', fontWeight: 600 }}
                            >
                                {isUploadingFile ? <Spinner animation="border" size="sm" /> : (minhChungUrl ? "Đã đính kèm" : "Lấy PDF đã ký")}
                            </Button>
                            <div className="custom-file" style={{ display: 'none', width: '220px', maxWidth: '100%', flex: '1 1 auto' }}>
                                <input type="file" className="custom-file-input" id="minhChungUpload" onChange={handleUploadMinhChung} accept=".pdf,image/*" />
                                <label className="custom-file-label text-truncate" htmlFor="minhChungUpload">
                                    {isUploadingFile ? "Đang tải..." : (minhChungUrl ? "Đã đính kèm" : "Tải lên minh chứng")}
                                </label>
                            </div>
                            <Button
                                className="modern-btn-primary"
                                size="sm"
                                onClick={handleSubmitStep1}
                                disabled={!minhChungUrl || !hasSavedItems || !hasAllRequiredSignatures || submittingStep1}
                            >
                                {submittingStep1 ? <Spinner animation="border" size="sm" /> : `Duyệt Bước 1 (${recordList.filter(x => x.trangThaiDuyet === 4).length})`}
                            </Button>
                        </div>
                    </div>

                    <div className="table-responsive" style={{ maxHeight: '480px', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '8px' }}>
                        <Table hover className="align-middle mb-0 cme-table">
                            <thead className="text-muted text-uppercase" style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 1, fontSize: '0.8rem', borderBottom: '2px solid #dee2e6' }}>
                                <tr>
                                    <th className="text-center" style={{ width: '40px' }}>
                                        <Form.Check
                                            type="checkbox"
                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                            checked={filteredAndSortedList.filter(x => x.trangThaiDuyet === 0).length > 0 && filteredAndSortedList.filter(x => x.trangThaiDuyet === 0).every(x => selectedIds.includes(x.id))}
                                        />
                                    </th>
                                    <th className="text-center" style={{ width: '50px' }}>STT</th>
                                    <th>Số CCCD</th>
                                    <th>Họ và tên</th>
                                    <th>Đơn vị / Khoa</th>
                                    <th className="text-center">Giờ Điểm danh Đến</th>
                                    <th className="text-center">Giờ Điểm danh Về</th>
                                    <th className="text-center" style={{ width: '150px' }}>Trạng thái</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan={8} className="text-center py-4">Đang tải dữ liệu...</td></tr>
                                ) : filteredAndSortedList.length === 0 ? (
                                    <tr><td colSpan={8} className="text-center py-4 text-muted">Không tìm thấy điều dưỡng nào phù hợp.</td></tr>
                                ) : (
                                    filteredAndSortedList.map((item, idx) => {
                                        return (
                                            <tr key={item.id}>
                                                <td className="text-center">
                                                    {item.trangThaiDuyet === 0 ? (
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={selectedIds.includes(item.id)}
                                                            onChange={(e) => handleSelectOne(item.id, e.target.checked)}
                                                        />
                                                    ) : (item.trangThaiDuyet === 4 || item.trangThaiDuyet === 1 || item.trangThaiDuyet === 3) ? (
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={true}
                                                            disabled={true}
                                                        />
                                                    ) : null}
                                                </td>
                                                <td className="text-center">{idx + 1}</td>
                                                <td>
                                                    <span id={`cccd-${item.userId}`}>
                                                        <CMEParticipantCell userId={item.userId} mode="username" />
                                                    </span>
                                                </td>
                                                <td>
                                                    <span id={`name-${item.userId}`}>
                                                        <UserInfoCell userId={item.userId} hideUsername={true} />
                                                    </span>
                                                </td>
                                                <td>
                                                    <span id={`unit-${item.userId}`}>
                                                        {unitMap[item.userId]?.code || '-'}
                                                    </span>
                                                </td>
                                                <td className="text-center font-weight-bold text-success">
                                                    {item.thoiGianDen ? moment(item.thoiGianDen).format('HH:mm:ss DD/MM') : '-'}
                                                </td>
                                                <td className="text-center font-weight-bold text-info">
                                                    {item.thoiGianVe ? moment(item.thoiGianVe).format('HH:mm:ss DD/MM') : '-'}
                                                </td>
                                                <td className="text-center">
                                                    {item.trangThaiDuyet === 0 && (
                                                        <span className="badge-status-pending">
                                                            <i className="fas fa-clock mr-1"></i>Chờ duyệt
                                                        </span>
                                                    )}
                                                    {item.trangThaiDuyet === 4 && (
                                                        <span
                                                            className="badge badge-info"
                                                            style={{
                                                                padding: '5px 10px',
                                                                borderRadius: '12px',
                                                                fontSize: '0.75rem',
                                                                backgroundColor: '#e3f2fd',
                                                                color: '#0d47a1',
                                                                fontWeight: 'bold',
                                                                display: 'inline-flex',
                                                                alignItems: 'center'
                                                            }}
                                                        >
                                                            <i className="fas fa-save mr-1"></i>Đã lưu (Đề xuất)
                                                        </span>
                                                    )}
                                                    {item.trangThaiDuyet === 1 && (
                                                        <span className="badge-status-step1">
                                                            <i className="fas fa-check-circle mr-1"></i>Hợp lệ Bước 1
                                                        </span>
                                                    )}
                                                    {item.trangThaiDuyet === 2 && (
                                                        <span className="badge-status-rejected">
                                                            <i className="fas fa-times-circle mr-1"></i>Bị từ chối
                                                        </span>
                                                    )}
                                                    {item.trangThaiDuyet === 3 && (
                                                        <span className="badge-status-approved">
                                                            <i className="fas fa-check-circle mr-1"></i>Đã tích điểm (B2)
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ borderTop: 'none' }}>
                    <Button variant="secondary" style={{ borderRadius: '8px', padding: '6px 16px', fontWeight: 600 }} onClick={handleClose}>Đóng</Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={openBulkActionModal}
                onHide={handleCloseBulkActionModal}
                centered
                backdrop="static"
                keyboard={false}
                style={{ zIndex: '99999' }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Nhập thông tin xác nhận</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Đường dẫn</Form.Label>
                            <Form.Control
                                type="text"
                                value={getFileNameFromPath(filePathAbsolute)}
                                disabled={true}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Username</Form.Label>
                            <Form.Control
                                type="text"
                                value={bulkUsername}
                                onChange={(e) => setBulkUsername(e.target.value)}
                                placeholder="Nhập username"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                value={bulkPassword}
                                onChange={(e) => setBulkPassword(e.target.value)}
                                placeholder="Nhập password"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Loại ký</Form.Label>
                            <select
                                className="form-control"
                                value={bulkLoaiKy}
                                onChange={(e) => setBulkLoaiKy(e.target.value)}
                            >
                                {objectLoaiKy.map((item, key) => (
                                    <option key={Number(key)} value={item.value}>
                                        {item.text}
                                    </option>
                                ))}
                            </select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Chức vụ ký</Form.Label>
                            <select
                                className="form-control"
                                value={bulkChuKy}
                                onChange={(e) => setBulkChuKy(e.target.value)}
                            >
                                {objectChuKy.map((item, key) => (
                                    <option
                                        key={Number(key)}
                                        value={item.value}
                                        disabled={signedFields.includes(item.value)}
                                    >
                                        {item.text}{signedFields.includes(item.value) ? ' - Đã ký' : ''}
                                    </option>
                                ))}
                            </select>
                        </Form.Group>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleConfirmBulkAction}>
                        Xác nhận
                    </Button>
                    <Button variant="secondary" onClick={handleCloseBulkActionModal}>
                        Hủy
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={openPdfViewer}
                onHide={() => setOpenPdfViewer(false)}
                size="xl"
                centered
                backdrop="static"
                keyboard={false}
                style={{ zIndex: '999999' }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Xem file PDF đã ký</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ maxHeight: '75vh', overflow: 'auto', padding: '16px', backgroundColor: '#f8f9fa' }}>
                    <div style={{ minWidth: '1100px', display: 'flex', justifyContent: 'center' }}>
                        <Document
                            file={resolveSignedPdfUrl(downloadUrl || getRelativeFilePath(filePathAbsolute))}
                            onLoadSuccess={onDocumentLoadSuccess}
                            loading="Đang tải PDF..."
                            error="Không tải được PDF"
                        >
                            {Array.from(new Array(numPages || 0), function (_, index) {
                                return (
                                    <Page
                                        key={`page_${index + 1}`}
                                        pageNumber={index + 1}
                                        width={1050}
                                        renderAnnotationLayer={false}
                                        renderTextLayer={false}
                                    />
                                );
                            })}
                        </Document>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setOpenPdfViewer(false)}>
                        Hủy
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CMEDieuDuongEvent;
